<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M18 52.7c10.9-2.3 9.4-15.3 9.1-18.2-.5-4.4-5.7-12-12.7-11.4-8.8.8-10.1 13.5-10.1 13.5C3.1 42.5 7.1 55 18 52.7zm11.5 22.6c-.3.9-1 3.3-.4 5.3 1.2 4.6 5.2 4.8 5.2 4.8H40v-14h-6.1c-2.7.8-4.1 3-4.4 3.9zm8.7-44.4c6 0 10.9-6.9 10.9-15.5C49 6.9 44.2 0 38.2 0S27.3 6.9 27.3 15.4c0 8.6 4.9 15.5 10.9 15.5zm25.8 1c8 1 13.2-7.5 14.2-14s-4.1-14-9.8-15.3C62.7 1.3 55.6 10.4 55 16.4c-.8 7.2 1 14.5 9 15.5zm19.7 38.2s-12.4-9.6-19.7-20c-9.8-15.3-23.8-9.1-28.5-1.3-4.6 7.8-11.9 12.7-12.9 14-1 1.3-15 8.8-11.9 22.6 3.1 13.8 14 13.5 14 13.5s8 .8 17.3-1.3 17.3.5 17.3.5S81 105.4 87 91.4s-3.3-21.3-3.3-21.3zM46.5 90.9H32.4c-6.1-1.2-8.5-5.4-8.8-6.1-.3-.7-2-4.1-1.1-9.8 2.6-8.5 10.2-9.1 10.2-9.1h7.5v-9.2l6.4.1v34.1zm26.3-.1H56.6c-6.3-1.6-6.6-6.1-6.6-6.1v-18l6.6-.1v16.2c.4 1.7 2.5 2 2.5 2h6.7v-18h7v24zm23.1-48c0-3.1-2.6-12.5-12.2-12.5s-10.9 8.8-10.9 15.1c0 6 .5 14.3 12.4 14 12-.2 10.7-13.5 10.7-16.6zm0 0"
        data-follow-fill="#4e6ef2"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
